import { useEffect } from 'react';
import { cn, firebaseAnalytics, Loader } from 'shared';
import { appStore } from 'app/store';
import { logEvent } from 'firebase/analytics';
import * as amplitude from '@amplitude/analytics-browser';
import { creditStore } from 'entities/credit';
import { ApiKeyInput, apiKeyStore } from 'entities/apiKey';
import { EServiceName } from 'entities/apiKey/api';

export const Developer = () => {
  const { user, regenerateApiKey, toggleCreateAccModal } = appStore();
  const {
    planFeatures,
    toggleFeatureBlockModal,
    isInactivePlan,
    toggleInactivePlanModal
  } = creditStore((state) => ({
    planFeatures: state.planFeatures,
    toggleFeatureBlockModal: state.toggleFeatureBlockModal,
    isInactivePlan: state.isInactivePlan,
    toggleInactivePlanModal: state.toggleInactivePlanModal
  }));

  const {
    apiKeys,
    isLoadingList,
    create,
    fetchAll,
    toggleConfirmationDeleteModal,
    isLoadingCreate
  } = apiKeyStore((state) => ({
    apiKeys: state.apiKeys,
    isLoadingList: state.isLoadingList,
    create: state.create,
    fetchAll: state.fetchAll,
    toggleConfirmationDeleteModal: state.toggleConfirmationDeleteModal,
    isLoadingCreate: state.isLoadingCreate
  }));

  useEffect(() => {
    fetchAll();
  }, []);

  const handleApiKeyRequest = () => {
    if (!user) toggleCreateAccModal();

    if (planFeatures?.api) {
      if (isInactivePlan) {
        toggleInactivePlanModal();
        return;
      }
      regenerateApiKey();
    } else {
      toggleFeatureBlockModal('api');
    }
  };

  const filteredApiKeys = apiKeys.filter(
    (apiKey) => apiKey.serviceName === 'api'
  );

  if (!user) return null;

  return (
    <div className="yep_ex-gap-4 flex yep_ex-flex-col yep_ex-px-4 yep_ex-overflow-auto">
      <p className="yep_ex-text-sm yep_ex-mb-6">
        Information and resources to help you to integrate with our API. Our
        guides offer step-by-step instructions and expert advice
      </p>
      <div className="yep_ex-flex yep_ex-flex-col yep_ex-gap-y-1 yep_ex-mb-6 yep_ex-rounded-lg md:yep_ex-w-44">
        {planFeatures?.api ? (
          <div className="yep_ex-flex yep_ex-flex-col yep_ex-gap-2 yep_ex-max-w-fit">
            <span className="yep_ex-text-sm yep_ex-font-medium yep_ex-text-neutral-700">
              Your API Key
            </span>
            <div
              className={`yep_ex-flex yep_ex-flex-col yep_ex-gap-2 yep_ex-w-full md:yep_ex-w-60 xl:yep_ex-w-[23rem] yep_ex-h-fit`}
            >
              {isLoadingList ? (
                <div>
                  <Loader size={20} />
                </div>
              ) : (
                <>
                  {filteredApiKeys.length === 0 && (
                    <div className="yep_ex-text-sm yep_ex-text-neutral-500">
                      No API keys found. Generate one to get started.
                    </div>
                  )}
                  {filteredApiKeys.map((key) => (
                    <ApiKeyInput
                      onDelete={() => toggleConfirmationDeleteModal(key.id)}
                      key={key.id}
                      value={key.encryptedKey}
                      inputClassName="yep_ex-border-neutral-300 placeholder:yep_ex-text-neutral-700"
                      copyClassName="yep_ex-border-transparent"
                    />
                  ))}
                </>
              )}
            </div>
            <button
              onClick={() => {
                create({
                  serviceName: EServiceName.API
                });
              }}
              className={cn(
                'yep_ex-text-sm yep_ex-rounded-md h-fit py-2.5 px-4 text-white yep_ex-flex yep_ex-gap-1',
                isLoadingCreate
                  ? 'yep_ex-bg-primary-400 yep_ex-cursor-not-allowed'
                  : 'yep_ex-bg-primary-600'
              )}
              disabled={isLoadingCreate}
            >
              {isLoadingCreate && <Loader isButton size={20} />}
              Generate API Key
            </button>
          </div>
        ) : (
          <button
            className="yep_ex-rounded-md yep_ex-h-fit yep_ex-py-[0.4375rem] yep_ex-bg-primary-700 yep_ex-text-white yep_ex-px-3.5 yep_ex-w-44 lg:yep_ex-w-auto"
            onClick={handleApiKeyRequest}
          >
            Request API Key
          </button>
        )}
      </div>
      <a
        href="https://docs.yepic.ai/reference/homepage"
        rel="noreferrer noopener"
        target="_blank"
        className="yep_ex-max-w-fit yep_ex-inline-flex yep_ex-justify-center yep_ex-items-center yep_ex-rounded-lg yep_ex-mb-4 yep_ex-text-neutral-700 yep_ex-font-semibold yep_ex-text-sm yep_ex-border yep_ex-border-neutral-300 yep_ex-px-3.5 yep_ex-py-2"
        onClick={() => {
          amplitude.track('express_open_api_docs');
          logEvent(firebaseAnalytics, 'express_open_api_docs');
        }}
      >
        API Documentation
      </a>
    </div>
  );
};
